import { GetAllProvinciasDtoIPagedEnumerable } from "api/Provincia.service"
import EmpresaService from "common/services/EmpresaService"
import { useEffect, useState } from "react"

const empresaService = new EmpresaService()

const mapTopOptions = (items = []) =>
  items.map((poblacion) => ({
    // @ts-expect-error TS(2339): Property 'descripcion' does not exist on type 'nev...
    label: poblacion.descripcion,
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    value: poblacion.id,
  }))

const mapProvinciasToOptions = (provincias = []) =>
  provincias.map((provincia) => ({
    // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
    label: provincia.nombre,
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    value: provincia.id,
  }))

const useEmpresa = ({ industriaId }: $TSMigrationFixMe) => {
  const [optionsIndustria, setOptionsIndustria] = useState([])
  const [optionsProvincias, setOptionsProvincias] = useState([])
  const [optionsCnae, setOptionsCnae] = useState([])

  const getCnaeByIndustriaId = async (id: $TSMigrationFixMe) => {
    if (!id) return
    empresaService.getCnaeByIndustria(id).then((res) => {
      // @ts-expect-error TS(2345): Argument of type '{ label: $TSFixMe; value: $TSFixMe; }[]' i...
      setOptionsCnae(mapTopOptions(res.data))
    })
  }

  useEffect(() => {
    async function getActividad() {
      empresaService.getAllIndustria().then((res) => {
        // @ts-expect-error TS(2345): Argument of type '{ label: $TSFixMe; value: $TSFixMe; }[]' i...
        setOptionsIndustria(mapTopOptions(res.data))
      })
    }

    async function getProvincias() {
      GetAllProvinciasDtoIPagedEnumerable().then((data) => {
        // @ts-expect-error TS(2345): Argument of type '{ label: $TSFixMe; value: $TSFixMe; }[]' i...
        setOptionsProvincias(mapProvinciasToOptions(data.items))
      })
    }

    getActividad()
    getProvincias()
    getCnaeByIndustriaId(industriaId)
  }, [industriaId])

  return {
    optionsIndustria,
    optionsCnae,
    optionsProvincias,
    getCnaeByIndustriaId,
  }
}

export default useEmpresa
